<template>
  <div class="w-100">
    <hr v-if="schema.hasHR" />
    <strong v-html="schema.text" />
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import { abstractField } from '@it/vue-form-generator'
import { GenField } from '@it/vue-form-generator'

@Component
export default class HeaderSeparator extends Mixins(abstractField) {
  schema!: GenField
  hasHR = false
}
</script>
